export default {
  excess: "過剰な責任",
  security: "保証金",
  fuel_policy: "燃料政策",
  like_for_like: "いいねにはいいね",
  full_to_full: "フルからフルへ",
  mileage: "走行距離: レンタルごとに {mileage} マイル",
  unlimited_mileage: "走行距離無制限",
  non_refundable: "返金不可",
  free_cancellation_until: "{date}までキャンセル無料",
  cancellation_with_terms: "キャンセル {0} に沿って ",
  t_c_text: "T&Cs",
  two_free_extras: "コレクションの 2 つの無料特典",
  glass_tyres_covered: "ガラスとタイヤが覆われています",
  spec_fuel_petrol: "ガソリン",
  spec_fuel_petrol_diesel: "ガソリン/ディーゼル",
};